<template>
    <v-layout row align-center justify-center pb-2>
        <v-flex v-if="productDetail.url" xs6 style="margin:2.5px">
            <v-btn style="width:100%" color="success" target="_blank" :href="productUrl">
                <div style="display:flex; flex-direction: row; justify-content: center;">
                    <div style="width: 30px;">
                        <v-img :src="getImgUrl('download')" style="width: 100%"></v-img>
                    </div>
                    <div style="display:flex; align-items: center; padding: 5px;">
                        <span>{{ $t('game.download') }}</span>
                    </div>
                </div>
            </v-btn>
        </v-flex>
        <v-flex v-if="productDetail.mobile_url" xs6 style="margin:2.5px">
            <v-btn style="width:100%;" color="warning" target="_blank" :href="productMobileUrl">
                <div style="display:flex; flex-direction: row; justify-content: center">
                    <div style="width: 30px;">
                        <v-img :src="getImgUrl('internet')" style="width: 100%"></v-img>
                    </div>
                    <div style="display:flex; align-items: center; padding: 5px;">
                        <span>{{ $t('game.website') }}</span>
                    </div>
                </div>
            </v-btn>
        </v-flex>
    </v-layout>
</template>

<script>
export default {
    name: 'Download-Button-Pannel',
    props: ["product"],
    data() {
        return {
    
        }
    },
    computed: {
        productDetail: function() {
            return this.product;
        },
        productUrl: function() {
            return '//' + this.productDetail.url;
        },
         productMobileUrl: function() {
            return '//' + this.productDetail.mobile_url;
        }
    },
    methods: {
        getImgUrl(img) {
            var images = require.context('@/assets/', false, /\.png$/);
            return images('./' + img + ".png");
        },
    }
}
</script>

<style scoped>
.v-btn {
    margin: 0px;
}
</style>


